import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Figure } from 'react-bootstrap';
import '../../../assets/scss/sections/_pharmacysoftware.scss';

const PharmacySoftware = ({ pharmacy_software_data, setting_data }) => {
  return (
    <>
      <section id="pharmacy_software">
        <h3 className="main_common_title pharmacy_software_title text-center wave_blue">
          <span className="common_span"> {setting_data?.home_page_pharmacy_software_title_1}</span>
          {setting_data?.home_page_pharmacy_software_title_2}
        </h3>
        <Container className="pharmacy_plus">
          <Row className="pharmacy_row">
            <div className="pharmacy_logo_Wrapper">
              {pharmacy_software_data.map((team) => (
                <div
                  className="pharmacy_software_wrapper"
                  key={team.home_pharmacy_software_id.toString()}>
                  <a href="#">
                    <div className="our_client_img">
                      <Figure>
                        <Figure.Image width={210} alt={team.title} src={team.image_url} />
                      </Figure>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </Row>
        </Container>
      </section>
    </>
  );
};
PharmacySoftware.propTypes = {
  pharmacy_software_data: PropTypes.array,
  setting_data: PropTypes.object,
};
export { PharmacySoftware };
